<template>
  <v-container>
    <v-card>
      <v-card-text>Página de retorno bancario</v-card-text>
      <page-title
        icon="mdi-pencil-box-outline"
        main="Assistência Social"
        sub="Importa arquivo de retorno"
        home="/social"
      />
      {{ content.line }}
      <v-row>
        <v-col
          cols="12"
          sm="12"
        >
          <input
            accept="text/plain"
            label="Retorno"
            type="file"
            ref="file"
            @change="selectFile()"
          >
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>
<script>
import PageTitle from '@/components/template/PageTitle'
export default {
  components: { PageTitle },
  name: 'RetornoBancario',
  data: () => ({
    file: '',
    content: {}
  }),
  methods: {
    selectFile () {
      this.file = this.$refs.file.files[0]
      const reader = new FileReader()
      if (this.file.name.includes('.txt')) {
        reader.onload = (res) => {
          this.cont = res.target.result
          this.content.line = this.cont.split('\n')
        }
        reader.onerror = (err) => console.log(err)
        reader.readAsText(this.file)
      }
      console.log('Resultado:' + this.content)
    }
  }
}
</script>
